// import React from 'react'
// import {Link} from 'react-router-dom'
// import user from '../assets/user.png'
import styled from 'styled-components';
import toast, {Toaster} from 'react-hot-toast';
import {useFormik} from 'formik';
import { resetValidate } from '../Helpers/validate';
import { Button } from "../styles/Button";
import PasswordInput from "./PasswordInput";
import UserMenu from '../user/UserMenu';
import PageHeader from "../components/PageCloseButton";
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'store/store';


const Reset = () => {
//  const  formik=useFormik({
//      initialValues:{
//        Password:'',
//        confirmPassword:''
       
//      },
//      validate:resetValidate,
//      validateOnBlur:false,
//      validateOnChange:false,
//      onSubmit:async values=>{
//       //  console.log(values)
//      }
//    })
 
 const navigate = useNavigate();
 const { auth } = useAuthStore();


  const [formData, setFormData] = useState({ 
    newPassword: "", 
    confirmPassword: ""
  });

  const handleChange = (e) => { 
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value, 
    }); 
  }; 

   const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.newPassword) {
      toast.error("Please enter a new password");
      return;
    }

  //   console.log("========== RESET START ==========");
  // console.log("AUTH OBJECT:", auth);
  // console.log("TOKEN:", auth?.token);
  // console.log("NEW PASSWORD:", formData.newPassword);


    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await axios.put(
        "/api/resetPassword",
        {
          newPassword: formData.newPassword
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        }
      );

      toast.success(
        res.data.message || "Password Reset Successfully"
      );

      navigate("/username");

    } catch (error) {
    //   console.log("========== RESET ERROR ==========");
    // console.log("STATUS:", error.response?.status);
    // console.log("DATA:", error.response?.data);
    // console.log("ERROR:", error);

      toast.error(
        error.response?.data?.error ||
        "Something went wrong"
      );
    }
  };
return (
  <Wrapper>
    <Toaster position='top-center' reverseOrder={false}></Toaster>
    <div className="grid grid-two-column">
          <UserMenu/>    
      <div className='user-container'>
         <PageHeader title="Reset Password" />  
          <header className='header-container'>
             <p className='subtitle'>Enter a New Password</p>
          </header>
          
          <form onSubmit={handleSubmit} autoComplete="off">
                 {/* <img className='user-img'src={user} alt='user-img'/> */}
                 <div className="form-fields">
                  
                  <PasswordInput 
                   name="newPassword"
                  type='password' 
                  className='password' 
                  placeholder='New password' 
                  onChange={handleChange}
                  />
                  <PasswordInput 
                  name="confirmPassword"   
                  type='password' 
                  className='password' 
                  placeholder='Repeat password'
                  onChange={handleChange} 
                  />
                  <Button 
                  type='submit'>
                  Reset
                  </Button>
                 </div>
          </form>
        <div>
         {/* <p className='user-para'>Can't get OTP? <span className='linkspan'><Link to='/recover'>Resend</Link></span></p> */}
      </div>
    </div>   
   </div> 
  </Wrapper>
   )
}
const Wrapper=styled.section`
 .grid-two-column {
    display: grid;
    grid-template-columns: 2fr 8fr;
    gap: 2rem;
     }

.user-container {
    width: 40%;
    margin: 3rem auto;
    border-radius: 0.8rem;
    background: ${({ theme }) => theme.colors.bg};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;  
    padding: 1rem; 
  }

.header-container {
   display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
   }

  .greeting {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin: 2rem 0;
    }

  .subtitle {
    font-size: 1.5rem;
    color: #0073e6;
    margin: 2rem;
  }

  hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 1.5rem 0;
  }

  hr {
    margin-top: 1.5rem;
    width: 100%;
    border: 1px solid black;
  }

.form-fields {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding : 1rem;
    width: 100%;
  }
@media (max-width: ${({ theme }) => theme.media.mobile}) {
 .grid {
    grid-template-columns: 1fr;
    }

  .user-container {
    width: 95%;
    margin: 2rem auto;
    }

} 
`;


export default Reset
